import { render } from "./InfoModal.vue?vue&type=template&id=16311c16&scoped=true&ts=true"
import script from "./InfoModal.vue?vue&type=script&lang=ts"
export * from "./InfoModal.vue?vue&type=script&lang=ts"

import "./InfoModal.vue?vue&type=style&index=0&id=16311c16&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16311c16"]])

export default __exports__